<template>
  <div class="delete-warning">
    <el-dialog :visible.sync="centerDialogVisible" :before-close="handleClose" center>
      <p class="delete-message-first">删除文件</p>
      <p class="delete-message-second">
        <span>此操作将永久删除该文件，是否确定删除</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
'use strict'
export default {
  data() {
    return {
      centerDialogVisible: false
    }
  },
  props: ['isShowDeleteWarning', 'deleteRecordId'],
  watch: {
    isShowDeleteWarning() {
      if (this.isShowDeleteWarning) {
        this.centerDialogVisible = true
      } else {
        this.centerDialogVisible = false
      }
    },
    deleteRecordId() {
      console.log(this.deleteRecordId)
    },
    deep: true
  },
  methods: {
    handleClose(done) {
      console.debug(done)
      this.$emit('inform', false)
    },
    confirm() {
      this.centerDialogVisible = false
      this.$emit('inform', true, this.deleteRecordId)
    },
    cancel() {
      this.centerDialogVisible = false
      this.$emit('inform', false, this.deleteRecordId)
    }
  }
}
</script>

<style>
.delete-warning .el-dialog.el-dialog--center {
  width: 507px;
  height: 227px;
  background: rgba(255, 255, 255, 1);
  margin-top: 33vh !important;
}
.delete-warning .el-dialog__header {
  padding: 0;
}
.delete-warning .el-dialog__body {
  padding: 0;
}
.delete-warning .el-dialog__footer {
  padding: 0;
}
.delete-warning .delete-message-first {
  display: inline-block;
  width: 96px;
  height: 33px;
  font-size: 24px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  margin-top: 40px;
  margin-left: 206px;
}
.delete-warning .delete-message-second {
  display: inline-block;
  width: 252px;
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 15px;
  margin-left: 128px;
}
.delete-warning .el-dialog__footer .el-button.el-button--default {
  float: left;
  width: 138px;
  height: 50px;
  border: 1px solid rgba(232, 232, 232, 1);
  margin-left: 97px;
  margin-top: 28px;
  border-radius: unset;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
}
.delete-warning .el-button.el-button--primary {
  float: right;
  width: 138px;
  height: 50px;
  background: rgba(75, 129, 198, 1);
  margin-right: 96px;
  margin-top: 28px;
  border-radius: unset;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
}
.el-dialog__close.el-icon.el-icon-close {
  color: #333;
  font-size: 14px;
}
</style>